import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import MainNavbar from './MainNavbar';
import { Box } from '@mui/material';
import SupportChat from './SupportChat';

const MainLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'Roboto Flex',
  })
);

const MainLayoutWrapper = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  background: '#FAF8F6',
  paddingTop: 70
});

const MainLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const MainLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'hidden'
});

const MainLayout = ( {children} ) => {

  return (
    <MainLayoutRoot>
      <MainNavbar />
      <MainLayoutWrapper>
        <MainLayoutContainer>
          <MainLayoutContent>
            <Box sx={{
              maxWidth:"500px",
              position:"absolute",
              bottom:0,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex:0,
            }}>
              <img
                src="/static/mainLayout-bg.png"
                width="100%"
              />
            </Box>
            {children}

          </MainLayoutContent>
        </MainLayoutContainer>
      </MainLayoutWrapper>
      {/* Le chat doit exister AVANT la connexion : le cas d'usage numero un est
        * quelqu'un qui n'arrive pas a entrer. La route publique du back a ete
        * concue pour ca ; sans ce montage, ces personnes ne l'atteignaient pas.
        * Ce layout couvre login, mot de passe oublie, code de validation et
        * inscription candidat. */}
      <SupportChat plateforme="scan" />
    </MainLayoutRoot>
  )
}

export default MainLayout;
